module.exports = "../../../../platform/assets/pageMainIcon/ig-business-processing-4.svg";